import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import LoaderComponent from '../../components/LoaderComponent'
import axios from 'axios'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {toast} from 'react-toastify'
import DataTableList from '../../components/DataTableList'
import {PATIENT_HEADERS} from '../../../../constants/RoleConstants'
import {PatientModel} from '../../../../entities/entities'
import MetaTags from '../../../../meta/MetaTags'

interface AllPatientsListingProfilePageProps {
  isLoading?: boolean
}

const AllPatientsListingProfilePage = ({isLoading}: AllPatientsListingProfilePageProps) => {
  const {doctorId} = useParams()
  const [patientsList, setPatientsList] = useState<PatientModel[]>([])
  const [loading, setLoading] = useState(true)

  // function to get data
  const fetchData = async () => {
    const queryParams = `uuid=${doctorId}`

    try {
      const response = await axios.get(
        API_ENDPOINTS.GET_MY_PATIENTS(queryParams)
      )

      if (response.data.status === 'Success') {
        setPatientsList(response.data?.data?.patients || [])
      } else {
        toast.error(response.data.message || 'Failed to assign device.')
      }
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      } else if (error instanceof Error) {
        toast.error(error.message)
      } else {
        toast.error('An unexpected error occurred')
      }
    } finally {
      setLoading(false)
    }
  }

  // fetch data
  useEffect(() => {
    fetchData()
  }, [])

  if (loading) return <LoaderComponent />

  // Function to filter headers and remove actions
  const filteredHeaders = PATIENT_HEADERS.filter(
    (header) => header.key !== 'settings' && header.key !== 'AssignedDoctor.full_name'
    // header.key != 'status'
  )

  return (
    <>
      <MetaTags title={'All Patients'} />

      <div className='card mb-5 mb-xl-10'>
        <div className='card-header d-flex justify-content-between align-items-center'>
          {/* Title */}
          <div className='card-title m-0 '>
            <h3 className='fw-bolder m-0'>All Patients</h3>
          </div>
        </div>

        <div className='card-body p-9'>
          <DataTableList
            columns={filteredHeaders}
            data={patientsList}
            showAddButton={false}
            showHeader={false}
          />
        </div>
      </div>
    </>
  )
}

export default AllPatientsListingProfilePage
